export const defaultColors = {
    primary: "#152A5F",
    secondary: '#575E71',
    on_primary: '#FFFFFF',
    on_secondary: '#FFFFFF',
    primary_container: '#DBE2FF',
    on_primary_container: '#011947',
    on_secondary_container: '#151A2D',
    surface: '#F9F8FE',
    surface_container: '#EEEDF3',
    on_surface: '#1A1B20',
    on_surface_variant: '#45454F',
    outline: '#747780',
    outline_variant: '#C5C5CF',
    surface_container_highest: '#FFFFFF',
    error:'#b91a1a',
    on_disabled_surface:'#a1a1a5',
    disabled_surface:'#dad9df',
};
